const STORAGE_KEY = 'seospider_ecwid_seo_fix_detail_tour_done_v1';

export function hasCompletedSeoFixDetailTour() {
    if (typeof window === 'undefined') return true;
    try {
        return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
        return true;
    }
}

export function markSeoFixDetailTourCompleted() {
    try {
        window.localStorage.setItem(STORAGE_KEY, '1');
    } catch {
        /* ignore */
    }
}
